import { render } from "./OnlineLoginPage.vue?vue&type=template&id=455418f7&scoped=true&ts=true"
import script from "./OnlineLoginPage.vue?vue&type=script&lang=ts"
export * from "./OnlineLoginPage.vue?vue&type=script&lang=ts"

import "./OnlineLoginPage.vue?vue&type=style&index=0&id=455418f7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455418f7"]])

export default __exports__